function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { ComponentType } from '@wix/ambassador-devcenter-components-v1-component/types';
import { EditorElementBuilder } from '@wix/component-protocol/builder';
import { legacySystemComponentsManifests } from '@wix/editor-system-components-legacy';
export let ManifestComponentExtensionType = function (ManifestComponentExtensionType) {
  ManifestComponentExtensionType[ManifestComponentExtensionType["OOI"] = ComponentType.WIDGET] = "OOI";
  ManifestComponentExtensionType[ManifestComponentExtensionType["BLOCKS"] = ComponentType.STUDIO_WIDGET] = "BLOCKS";
  ManifestComponentExtensionType[ManifestComponentExtensionType["BUILDER"] = ComponentType.EDITOR_REACT_COMPONENT] = "BUILDER";
  ManifestComponentExtensionType["SYSTEM"] = "SYSTEM";
  ManifestComponentExtensionType["UNKNOWN"] = "UNKNOWN";
  return ManifestComponentExtensionType;
}({});
const predefinedManifestStore = new Map(Object.entries(legacySystemComponentsManifests).map(_ref => {
  let [compType, manifest] = _ref;
  return [compType, {
    extensionType: ManifestComponentExtensionType.SYSTEM,
    manifest,
    metadata: null
  }];
}));
var _store = /*#__PURE__*/new WeakMap();
export class ManifestStore {
  constructor(manifestHelpers) {
    this.manifestHelpers = manifestHelpers;
    _classPrivateFieldInitSpec(this, _store, new Map(predefinedManifestStore));
  }
  getManifest(compType) {
    var _classPrivateFieldGet2;
    return (_classPrivateFieldGet2 = _classPrivateFieldGet(_store, this).get(compType)) == null ? void 0 : _classPrivateFieldGet2.manifest;
  }
  getMetadata(compType) {
    var _classPrivateFieldGet3;
    return (_classPrivateFieldGet3 = _classPrivateFieldGet(_store, this).get(compType)) == null ? void 0 : _classPrivateFieldGet3.metadata;
  }
  getExtensionType(compType) {
    var _classPrivateFieldGet4;
    return (_classPrivateFieldGet4 = _classPrivateFieldGet(_store, this).get(compType)) == null ? void 0 : _classPrivateFieldGet4.extensionType;
  }
  has(compType) {
    return _classPrivateFieldGet(_store, this).has(compType);
  }
  get(compType) {
    return _classPrivateFieldGet(_store, this).get(compType);
  }
  getByEditorPointer(editorPointer) {
    const compType = this.manifestHelpers.getCompType(editorPointer);
    return this.get(compType);
  }
  getAll() {
    return Object.fromEntries(_classPrivateFieldGet(_store, this).entries());
  }
  getMetadataByEditorPointer(editorPointer) {
    return this.getMetadata(this.manifestHelpers.getCompType(editorPointer));
  }
  getExtensionTypeByEditorPointer(editorPointer) {
    const compType = this.manifestHelpers.getCompType(editorPointer);
    return this.getExtensionType(compType);
  }

  /**
   * returns the EditorElement | InlineElement.. not manifest itself
   */
  getManifestByEditorPointer(editorPointer) {
    const manifest = this.getManifest(this.manifestHelpers.getCompType(editorPointer));
    const elementPath = (editorPointer.innerElementPath ?? []).slice(1).join('.');
    if (manifest && elementPath.length) {
      // TODO: exception?
      return new EditorElementBuilder(manifest == null ? void 0 : manifest.editorElement).getElementByPath(elementPath);
    } else {
      return manifest == null ? void 0 : manifest.editorElement;
    }
  }
  async setManifest(compType, extensionType, manifest, metadata) {
    _classPrivateFieldGet(_store, this).set(compType, {
      extensionType,
      manifest,
      metadata: metadata ?? null
    });
    return manifest;
  }
}
//# sourceMappingURL=ManifestStore.js.map